import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    const processSession = async () => {
      try {
        const res = await authAPI.googleSession(sessionId);
        const { token, user } = res.data;
        login(user, token);
        navigate('/dashboard', { replace: true, state: { user } });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, login]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center animate-fade-in">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
